module.exports = "/_next/static/images/policeWalkieTalkie-568754d0a4fc16e43ea450230869c7ad.png";